<template>
  <div class="mby-wrapper">
    <!-- Map -->
    <ThreatenedSpeciesMap id="mby-top"></ThreatenedSpeciesMap>
      
    <!-- Electorate Details -->
    <ElectorateDetails
      :gradesPopupLink="gradesPopupLink"
    ></ElectorateDetails>

    <SpeciesDetails
      class="mby-species-details"
      :datalayerName="datalayerName"
      :programName="programName"
      :messageId="messageId"
      :cards="cards"
      :thankYouUrl="thankYouUrl"
      :privacyPolicyUrl="privacyPolicyUrl"
    ></SpeciesDetails>

    <!-- Disclaimer -->
    <p class="mby-disclaimer">
      We acknowledge the First Nations language groups mentioned in the My
      Backyard tool as the holders of their language and cultural knowledge.
    </p>
  </div>
</template>

<script>
import SpeciesDetails from "./SpeciesDetails.vue";
import ElectorateDetails from "./ElectorateDetails.vue";
import ThreatenedSpeciesMap from "./ThreatenedSpeciesMap.vue";

export default {
  name: "ThreatenedSpecies",
  components: {
    SpeciesDetails,
    ElectorateDetails,
    ThreatenedSpeciesMap
  },
  props: {
    // -- Electorate Details related props 
    gradesPopupLink: {
      type: String,
      default: "https://www.wwf.org.au/",
    },
    // -- END
    
    // -- SpeciesDetails related props 
    datalayerName: {
      type: String,
      required: true,
    },

    // MARKETO
    programName: {
      type: String,
      required: true,
    },

    messageId: {
      type: String,
    },

    cards: {
      type: Array,
      default: () => [
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/my-backyard-landing-image-1.jpg",
          title: "Our wildlife is uniquely Australian",
          description:
            "Australia is home to an incredible array of threatened wildlife found nowhere else in the world",
        },
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/my-backyard-landing-image-2.jpg",
          title: "1,800 animals and plants are at risk of extinction",
          description:
            "Sadly, iconic wildlife, including east coast koalas and the greater glider, are at risk of disappearing forever",
        },
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/my-backyard-landing-image-3.jpg",
          title: "Protecting our wildlife and wild places",
          description:
            "To bring our wildlife back from the brink of extinction, we need stronger national nature laws that protect them and the places they call home. Add your voice today and make an impact",
        },
      ],
    },
    
    thankYouUrl: {
      type: String,
      default: "https://wwf.org.au/thank-you-for-making-a-difference/"
    },
    
    privacyPolicyUrl: {
      type: String,
      default:"https://wwf.org.au/about-us/privacy-policy/"
    },
    // -- END
  },
};
</script>

<style scoped>
/* Hidden overflow to get rid of double scrolling within the iframe on live */
.mby-wrapper {
  overflow: hidden;
}

@media screen and (min-width: 1250px) {
  .mby-wrapper {
    height: 100%;
  }
}

/* Species details in the middle */
.mby-species-details {
  position: relative;
  top: -250px;
  padding-top: 50px;
}
@media screen and (max-width: 1250px) {
  .mby-species-details {
    top: -330px;
  }
}
@media only screen and (max-width: 64em) {
  .mby-species-details {
    padding-top: 40px;
  }
}

/* Disclaimer */
.mby-disclaimer {
  text-align: center;
  top: -220px;
  margin-bottom: -200px;
}

@media screen and (max-width: 1250px) {
  .mby-disclaimer {
    top: -310px;
    margin-bottom: -290px;
  }
}

/* Style from elcom */
p {
  font-family: 'Lato',sans-serif;
  position: relative;
  margin: 0;
  font-size: 16px;
}

@media only screen and (max-width: 40em) {
  p {
    font-size: 15px;
    line-height: 23px;
  }
}
/* END */
</style>



// WEBPACK FOOTER //
// ThreatenedSpecies.vue?6aed93d6